module.exports = __webpack_public_path__ + "static/media/leg_extension_machine.e94cecc3.png";